var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full pr-20px"},[_c('div',{staticClass:"w-full h-full overflow-auto"},[_c('iframe',{staticClass:"w-full h-full",attrs:{"src":_vm.iframeSrc,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }